// Formatador de moeda compartilhado pelos cards de checkout (voo/locação).
// Cache por (locale, moeda) para evitar recriação de Intl.NumberFormat a cada render.
const currencyFmtCache = new Map<string, Intl.NumberFormat>();

/** Formata um valor monetário com a moeda do backend no locale dado (default
 *  pt-BR). O locale vem de `useGenUiI18n().locale` no caller do kit. `whole` corta
 *  as casas decimais (a economia estimada do planner: "R$ 150", não "R$ 150,00"). */
export function formatCurrency(
  amount: number,
  currency: string,
  locale: string = 'pt-BR',
  { whole = false }: { whole?: boolean } = {},
): string {
  const key = `${locale}:${currency}:${whole ? 'whole' : 'cents'}`;
  let fmt = currencyFmtCache.get(key);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      ...(whole ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
    });
    currencyFmtCache.set(key, fmt);
  }
  return fmt.format(amount);
}

/** Formata o saldo de orçamento corporativo. Usa o código de moeda do backend
 *  (via Intl) quando presente; senão o símbolo do backend; sem nenhum dos dois,
 *  número puro no locale sem símbolo. Nunca assume uma moeda — o budget traz
 *  `currency`/`symbol` opcionais e nem sempre os manda. */
export function formatBudgetBalance(
  balance: number,
  currency?: string,
  symbol?: string,
  locale: string = 'pt-BR',
): string {
  if (currency) return formatCurrency(balance, currency, locale);
  const n = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(balance);
  return symbol ? `${symbol} ${n}` : n;
}
